import { render, staticRenderFns } from "./MyContestZoneSetting.vue?vue&type=template&id=60356d54&scoped=true&"
import script from "./MyContestZoneSetting.js?vue&type=script&lang=js&"
export * from "./MyContestZoneSetting.js?vue&type=script&lang=js&"
import style0 from "./MyContestZoneSetting.scss?vue&type=style&index=0&id=60356d54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60356d54",
  null
  
)

export default component.exports